import { sessionRoutes } from '@/routes/authenticated/session.js'
import { verificationRoutes } from '@/routes/authenticated/verification.js'
import { workOrderRoutes } from '@/routes/authenticated/work-orders.js'
import { genericRoutes } from '@/routes/generic.js'
import { unauthenticatedRoutes } from '@/routes/unauthenticated/unauthenticated.js'

export const routes = [
  ...genericRoutes,
  ...unauthenticatedRoutes,
  ...sessionRoutes,
  ...verificationRoutes,
  ...workOrderRoutes,
]
